import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
import useGraphRadio from '../../utils/useGraphRadio';
import Shimmer_graph from '../shimmer_graph';
import PopoverComponent from '../popover';
import { Card } from 'react-bootstrap';
import { useFilterContext } from '../FilterContext';
import AverageDisplay from './Average_value';
import SegmentedControl from './SegmentedControl';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import Zoom from '../Zoom';
import DownloadButtonComponent from '../DownloadButtonComponent';
import AIToggleButton from '../AIToggleButton';

const AverageSpeed = ({ value }) => {
  const [average_speed, set_average_speed] = useState(null);
  const radio_query = useGraphRadio();
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const [avg_value,setavg_value]= useState(value.average_speed[2]['average'])
  const unit = 'km/h'; 
  const [downloadData, setDownloadData] = useState(JSON.parse(value.average_speed[3]));
  const [chartType, setChartType] = useState("Bar");
  const { chartData, fetchSegmentedChart } = useSegmentedChartQuery();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Handle segmented chart fetch
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSegmentedChart({
          vinShort: value.vin_short,
          chartType,
          columnname: "Average Speed",
        });

        console.log("📊 Segmented chart response:", data);
        
        if (chartType === "Bar") {
          set_average_speed(JSON.parse(data.graph_data[0]));
          setDownloadData(JSON.parse(data.graph_data[3]));
        } else {
          set_average_speed(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[1]));
        }
      } catch (error) {
        console.error("❌ Error fetching chart data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!isInitialLoad && chartType && value?.vin_short) {
      fetchData();
    } else {
      setIsInitialLoad(false);
    }
  }, [chartType]);



  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };

  // Handle radio button fetch
  useEffect(() => {
    if (radio_buttons_test) {
      console.log("🔄 Radio button changed:", radio_buttons_test);

      setIsLoading(true);

      const requestParams = {
        vins_short: [value.vin_short],
        radio_value: radio_buttons_test,
        columnname: "Average Speed",
        startDate,
        endDate,
        filterdata: filterdata,
        resetdata: filterdata?.resetdata
      };

      console.log("📡 Fetching graph data with:", requestParams);

      radio_query(requestParams)
        .then(data => {
          console.log("✅ Response from radio_query:", data);

          try {
            const graphData = JSON.parse(data.jsonData.graph_data[0]);
            const avgVal = data.jsonData.graph_data[2]?.average;

            set_average_speed(graphData);
            setavg_value(avgVal);
            setDownloadData(JSON.parse(data.jsonData.graph_data[3]));
            
            console.log("📊 Graph updated:", graphData);
            console.log("📈 Average value:", avgVal);
          } catch (err) {
            console.error("❌ Error parsing graph_data:", err);
          }
        })
        .catch(error => {
          console.error("❌ Error in radio_query:", error);
        })
        .finally(() => {
          console.log("⏳ Finished radio_query fetch cycle");
          setIsLoading(false);
        });
    }
  }, [radio_buttons_test]);

  useEffect(() => {
  }, [average_speed]);

  // Initial fallback data
  useEffect(() => {
    if (!average_speed && value?.average_speed?.[0]) {
      try {
        set_average_speed(JSON.parse(value.average_speed[0]));
        setDownloadData(JSON.parse(value.average_speed[3]));
      } catch (error) {
        console.error("Error parsing fallback average_speed JSON", error);
      }
    }
  }, [value, average_speed]);


  

  return (
    <Card className="card_ride">
      {/* Title and Info Icon */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px',
          
        }}
      >
        <div style={{ flex: 1, textAlign: 'center' }}>
          <ManText className="card-title-text" variant="component-l" as="span" size="l">
            Average speed
          </ManText>
        </div>
        <div style={{ flexShrink: 0,
    display: 'flex',
    alignItems: 'center', // Ensure icon aligns with text
    height: '100%', // Match height to parent for consistent alignment
    flexDirection:"row-reverse" }}>
          <PopoverComponent
            id="Average_speed"
            content="<b>Daily Average Speed:</b> This KPI displays the daily average speed of the vehicle(s).<br/><br/><b>Telematic Raw Data:</b><br/>• TBM3: payloaddecoded_totaldrivendistance_value<br/>• CM4: payload_electricmessagesystem_totaldrivendistance<br/><br/><b>Time Series Data:</b><br/>If multiple vehicles are selected average values are displayed. Days without data are not taken into account for the calculation.<br/><br/><b>Histogram:</b><br/>Each bar represents the number of days that fall within a certain range (bin) of <b>daily average speed values</b>. All daily values since start of data acquisition for the selected vehicle(s) are visualized per default.<br/><br/><b>Boxplot:</b><br/>The boxplot shows the <b>distribution of daily average speed values</b> for the selected vehicle(s) since start of data acquisition. If multiple vehicles are selected, the boxplot reflects the <b>combined distribution</b> of all their daily values.<br/>• The <b>box</b> represents the <b>middle 50%</b> of values (from the 25th percentile ('q1') to the 75th percentile ('q3'))<br/>• The <b>line inside the box</b> shows the <b>median</b> (50th percentile)<br/>• The whiskers extend to show the range of typical values ('min' and 'max') and visualize <b>the spread of the data</b> beyond the central box."
          />
              <Zoom
    chartData={average_speed?.data}
    chartLayout={average_speed?.layout}
    chartTitle="Average speed"
  />
            <DownloadButtonComponent data={downloadData} fileName='average_speed_data.xlsx' sheetName="Average Speed Data" />
        </div>
      </div>
  
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
          marginTop: '16px',
        }}
      >
        {/* Left: Average value (only for Bar) */}
        {chartType === 'Bar' ? (
          <div style={{ flexShrink: 0 }}>
            <AverageDisplay averages={avg_value} unit="km/h" />
          </div>
        ) : (
          <div style={{ width: '150px' }} />
        )}
  
        {/* Center: Radio Buttons (only for Bar) */}
        {chartType === 'Bar' ? (
          <ManRadioButtonGroup
            name="Average Speed"
            invalid="false"
            onManChange={handleSelectChange1}
            style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}
          >
            <ManRadioButton
              name="Average Speed"
              label="Daily"
              value="Daily"
              checked            
              />
            <ManRadioButton
              name="Average Speed"
              label="Monthly"
              value="Monthly"
              // checked={radio_buttons_test?.['Average Speed'] === 'Monthly'}
            />
            <ManRadioButton
              name="Average Speed"
              label="Yearly"
              value="Yearly"
              // checked={radio_buttons_test?.['Average Speed'] === 'Yearly'}
            />
          </ManRadioButtonGroup>
        ) : (
          <div style={{ flexGrow: 1 }} />
        )}
  
        {/* Right: Segmented Control */}
        <div style={{ flexShrink: 0 }}>
          <SegmentedControl selected={chartType} onChange={(type) => setChartType(type)} />
        </div>
      </div>
  
      {/* Chart and Text */}
      {isLoading ? (
        <Shimmer_graph />
      ) : (
        average_speed && (
          <>
            <Plot
              data={average_speed.data}
              layout={{
                ...average_speed.layout,
                autosize: true,
                responsive: true,
                margin: chartType === 'Bar' 
                  ? { t: 10, r: 10, l: 10, b: 10 }
                  : { t: 10, r: 10, l: 50, b: 200 }
              }}
              useResizeHandler={true}
            />

            {/* 🔥 AI Toggle Button - Only show for Bar charts with data */}
            {chartType === 'Bar' && downloadData?.length > 0 && (
              <div style={{
                display: 'flex',
                justifyContent: 'flex-start',
                paddingLeft: '10px',
                marginTop: '8px',
                marginBottom: '8px'
              }}>
                <AIToggleButton
                  downloadData={downloadData}
                  radioButtonState={radio_buttons_test || { 'Average Speed': 'Daily' }}
                  kpiName="Average Speed"
                  chartType={chartType}
                  vinShort={value.vin_short}
                  title="AI | Automotive Intelligence - Average Speed Analysis"
                />
              </div>
            )}
          </>
        )
      )}
    </Card>
  );
  
};

AverageSpeed.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    average_speed: PropTypes.array.isRequired,
  }).isRequired,
};

export default AverageSpeed;
  